<template>
  <div>
    <div>
      <h1 class="text-center">Reward Category</h1>
      <div>
        <ListRewardCategory />
      </div>
    </div>
  </div>
</template>

<script>
import ListRewardCategory from "@/views/RewardCategory/ListRewardCategory.vue";
export default {
  components: {
    ListRewardCategory,
  },
};
</script>
